// The server's clock, as the client sees it (owner 2026-10-18: a PC running 10 minutes fast showed
// fresh radishes ripe, and the server refused to harvest them). Every state reply carries
// server_now_ms; the gap to the device clock is kept here, and whatever compares with a server
// time (a crop's ready_at, fuel, animals, trees, the day cycle) asks serverNow() instead of Date.now().
let offsetMs = 0;

export function serverNow() { return Date.now() + offsetMs; }

// sentMs / recvMs: the device clock around the request — the reply was stamped somewhere between.
export function noteServerTime(serverMs, sentMs, recvMs) {
  if (!Number.isFinite(serverMs) || serverMs <= 0) return;
  offsetMs = Math.round(serverMs - (sentMs + recvMs) / 2);
}

export function serverOffsetMs() { return offsetMs; }
